module.exports = __webpack_public_path__ + "static/media/Christie_Logo_GS.62faaa77.png";